import CardSquare from '@/common/components/cardSquare/CardSquare';
import { Link } from 'react-router-dom';
import FileDetailIcon from '@/common/assets/icons/fileDetail.svg?react';
import { FILE_DETAIL_LINKS } from '@/modules/FileDetail/FileDetailLinks';
import { FileInformationCardProps } from '@/modules/FileDetail/components/entryTabs/Cards/FileInformationCard/FileInformationCard.types.ts';

const FileInformationCard = ({ title }: FileInformationCardProps) => {
  return (
    <Link to={FILE_DETAIL_LINKS.information}>
      <CardSquare title={title} renderIcon={() => <FileDetailIcon />} />
    </Link>
  );
};
export default FileInformationCard;
